export default __webpack_public_path__ + "static/media/referal-copy.f456006c.svg";